import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import TimestampManager from '../../utils/TimestampManager';
import DynamicAction from '../../utils/DynamicAction';
import { DynamicActionKey } from '../../utils/DynamicAction/DynamicAction';
import PanelType from './types';
import LivePanelsInterface from '../../api/LivePanelsInterface';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { FAVOURITE_ONBOARDING_STEPS as MOBILE_FAVOURITE_ONBOARDING_STEPS } from '../../../mobile/components/OnboardingLayer/onboardingSteps';
import { FAVOURITE_ONBOARDING_STEPS as WEB_FAVOURITE_ONBOARDING_STEPS } from '../../../web/src/components/OnboardingLayer/onboardingSteps';
import audio from '../../utils/audio';
import store from '../../state/store';
import { setGameProvider } from '../../state/actions/game';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import useProgressiveJackpots from '../../hooks/useProgressiveJackpots';
import { FE_PROGRESSIVE_JACKPOTS, FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import { BOOLEANS, PLATFORM } from '../../constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import utils from '../../utils';
import NotificationContext from '../../context/NotificationContext';
/** @typedef {import('../../api/Constants').LivePanelInfo} LivePanelInfo */

/** @typedef {import('../../api/Constants').LobbyItemsInfo} LobbyItemsInfo */

/** @typedef {import('../../api/Constants').MobileUrls} MobileUrls */

var GameTile = /*#__PURE__*/function (_Component) {
  _inherits(GameTile, _Component);

  var _super = _createSuper(GameTile);

  function GameTile(props) {
    var _this;

    _classCallCheck(this, GameTile);

    _this = _super.call(this, props);
    _this.timer = null;

    _this.initExpireTimer = function () {
      /** @type {LivePanelInfo} */
      var itemData = _this.props.itemData;

      if (itemData.seconds_until_expiry) {
        _this.timer = TimestampManager.register(itemData.seconds_until_expiry * 1000, _this._expireHandler);
      }
    };

    _this.isInFavouriteGameList = function () {
      var itemId = _this.props.itemData.item_id;
      var favgames = _this.props.favouriteGames.gameList;

      if (favgames.length == 0) {
        _this.setState({
          isFavourite: false
        });
      } else {
        for (var game in favgames) {
          if (game) {
            if (favgames[game].game_id == "".concat(itemId)) {
              _this.setState({
                isFavourite: true
              });

              return;
            }

            _this.setState({
              isFavourite: false
            });
          }
        }
      }
    };

    _this._expireHandler = function () {
      _this.setState({
        expired: true
      });
    };

    _this._showModal = function (modalType, itemData) {
      QueryParamsProxy.setQueryParams(_objectSpread(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType), itemData ? _defineProperty({}, RouteParamConstants.PARAM_FAVOURITE_GAME_ID, itemData.item_id) : {}));
    };

    _this._addFavouriteGame = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var item_id, favgames, game, newFavGame, _this$props, onboardingStep, setOnboardingStep, setFavouriteGames, addFavouriteResponse;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                audio.onClick();

                if (_this.userCanFavourite()) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", false);

              case 3:
                event.stopPropagation();
                item_id = _this.props.itemData.item_id;

                if (item_id) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                favgames = _this.props.favouriteGames.gameList;
                _context.t0 = _regeneratorRuntime.keys(favgames);

              case 9:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 15;
                  break;
                }

                game = _context.t1.value;

                if (!(favgames[game].game_id == "".concat(item_id))) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return");

              case 13:
                _context.next = 9;
                break;

              case 15:
                newFavGame = {};
                newFavGame.game_id = "".concat(item_id);
                newFavGame.game_name = '';
                _context.prev = 18;
                _this$props = _this.props, onboardingStep = _this$props.onboardingStep, setOnboardingStep = _this$props.setOnboardingStep, setFavouriteGames = _this$props.setFavouriteGames;
                _context.next = 22;
                return LivePanelsInterface.addFavouriteGame(item_id);

              case 22:
                addFavouriteResponse = _context.sent;

                _this.setState({
                  isFavourite: true
                });

                favgames.push(newFavGame);
                setFavouriteGames(favgames);

                if (utils.getPlatform() === PLATFORM.WEB) {
                  if (onboardingStep === WEB_FAVOURITE_ONBOARDING_STEPS.PICK_FAVOURITE) {
                    setOnboardingStep(WEB_FAVOURITE_ONBOARDING_STEPS.GO_TO_FAVOURITES);
                    Logger.sendEvent(EVENT_TYPES.TUTORIAL_STEP_COMPLETE, {
                      id: ONBOARDING_FLOWS.FAVOURITES,
                      step: 2
                    });
                  }
                } else if (onboardingStep === MOBILE_FAVOURITE_ONBOARDING_STEPS.PICK_FAVOURITE) {
                  setOnboardingStep(MOBILE_FAVOURITE_ONBOARDING_STEPS.OPEN_MENU);
                  Logger.sendEvent(EVENT_TYPES.TUTORIAL_STEP_COMPLETE, {
                    id: ONBOARDING_FLOWS.FAVOURITES,
                    step: 2
                  });
                }

                Logger.sendEvent(EVENT_TYPES.FAVOURITE_GAME_ADDED, {
                  game_id: item_id
                });
                return _context.abrupt("return", addFavouriteResponse);

              case 31:
                _context.prev = 31;
                _context.t2 = _context["catch"](18);

                _this.context.addNotification({
                  message: getText(TEXT_KEY.ADD_FAVOURITE_ERROR),
                  title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                  button: getText(TEXT_KEY.OK)
                });

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[18, 31]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this._removeFavouriteGameConfirmation = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var _this$props2, itemData, setFavouriteGames, favouriteGames, itemId, favgames, updatedFavGames, removeFavouriteResponse;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                audio.onClick();

                if (_this.userCanFavourite()) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                event.stopPropagation();
                _this$props2 = _this.props, itemData = _this$props2.itemData, setFavouriteGames = _this$props2.setFavouriteGames, favouriteGames = _this$props2.favouriteGames;
                itemId = itemData.item_id;
                favgames = favouriteGames.gameList;
                updatedFavGames = favgames.filter(function (game) {
                  return game.game_id !== "".concat(itemId);
                });
                _context2.prev = 8;
                _context2.next = 11;
                return LivePanelsInterface.removeFavouriteGame(itemId);

              case 11:
                removeFavouriteResponse = _context2.sent;
                setFavouriteGames(updatedFavGames);
                Logger.sendEvent(EVENT_TYPES.FAVOURITE_GAME_REMOVED, {
                  game_id: itemId
                });
                return _context2.abrupt("return", removeFavouriteResponse);

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](8);

                _this.context.addNotification({
                  message: getText(TEXT_KEY.REMOVE_FAVOURITE_ERROR),
                  title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                  button: getText(TEXT_KEY.OK)
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[8, 17]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this._clickHandler = function () {
      audio.onClick();
      var _this$props3 = _this.props,
          clickHandler = _this$props3.clickHandler,
          itemData = _this$props3.itemData,
          navigation = _this$props3.navigation;
      store.dispatch(setGameProvider(itemData.PROVIDER));

      if (clickHandler) {
        clickHandler(itemData);
      }
      /** @type {LivePanelInfo} */


      itemData.item_id = itemData.GAME_ID;
      itemData.item_type = PanelType.GAMES;

      if (!itemData.item_id && !itemData.id) {
        return;
      }

      switch (itemData.item_type) {
        case PanelType.GAMES:
        case PanelType.FEATURED_GAMES:
        case PanelType.NEW_GAMES:
          if (itemData.SNEAK_PEEK_END_DATE) {
            DynamicAction.getActionCallback("sneakPeek:".concat(itemData.GAME_ID, ",").concat(itemData.SNEAK_PEEK_END_DATE), navigation)();
          } else {
            DynamicAction.getActionCallback("".concat(DynamicActionKey.LAUNCH_GAME, ":").concat(itemData.item_id), navigation)();
          }

          break;

        case PanelType.NEWS:
        case PanelType.EVENTS:
        case PanelType.SALES:
        default:
          _this.context.addNotification({
            message: getText(TEXT_KEY.PANEL_NOT_SUPPORTED_ERROR),
            title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
            button: getText(TEXT_KEY.OK)
          });

          break;
      }
    };

    _this.userCanFavourite = function () {
      var _this$props4 = _this.props,
          itemData = _this$props4.itemData,
          userCanFavourite = _this$props4.userCanFavourite;

      if (itemData.item_type == 'featured-game' || itemData.item_type == 'new-game' || !itemData.item_id) {
        return false;
      }

      return userCanFavourite;
    };

    _this.changeFtueStep = function (step) {
      _this.props.setOnboardingFtueStep(step);
    };

    _this.openFtueOnboarding = function (message, position) {
      _this.props.setOnboardingHighlightedPosition(position, message);
    };

    _this.state = {
      expired: false,
      isFavourite: false
    };
    return _this;
  }

  _createClass(GameTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initExpireTimer();
      this.isInFavouriteGameList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
          favouriteGames = _this$props5.favouriteGames,
          itemData = _this$props5.itemData;
      var prevFavouriteGames = prevProps.favouriteGames;

      if (favouriteGames.gameList && prevFavouriteGames && favouriteGames.gameList.length != prevFavouriteGames.gameList.length || itemData.item_id !== prevProps.itemData.item_id) {
        this.isInFavouriteGameList();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        TimestampManager.unregister(this.timer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      /** @type {LivePanelInfo} */
      var _this$props6 = this.props,
          itemData = _this$props6.itemData,
          render = _this$props6.render,
          ftueStep = _this$props6.ftueStep;

      var _useFeatureFlags = useFeatureFlags(),
          hasFeature = _useFeatureFlags.hasFeature;

      var _useProgressiveJackpo = useProgressiveJackpots(),
          getProgressiveJackpotsData = _useProgressiveJackpo.getProgressiveJackpotsData;

      var sneakPeekTimer = hasFeature(FE_SNEAK_PEEK) && itemData.SNEAK_PEEK_END_DATE;
      var progressiveJackpotsData = hasFeature(FE_PROGRESSIVE_JACKPOTS) && itemData.HAS_PROGRESSIVE_JACKPOTS && getProgressiveJackpotsData(itemData.GAME_ID);
      var _this$state = this.state,
          expired = _this$state.expired,
          isFavourite = _this$state.isFavourite;
      return render({
        cacheId: this.props.cacheId,
        data: itemData,
        expired: expired,
        clickHandle: this._clickHandler,
        isFavourite: isFavourite,
        addFavouriteGame: this._addFavouriteGame,
        removeFavouriteGame: this._removeFavouriteGameConfirmation,
        userCanFavourite: this.userCanFavourite(),
        locked: itemData.UNLOCKED !== BOOLEANS.TRUE,
        openFtueOnboarding: this.openFtueOnboarding,
        changeFtueStep: this.changeFtueStep,
        ftueStep: ftueStep,
        sneakPeekTimer: sneakPeekTimer,
        progressiveJackpotsData: progressiveJackpotsData
      });
    }
  }]);

  return GameTile;
}(Component);

GameTile.contextType = NotificationContext;
export { GameTile as default };